import React, { Fragment } from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import './css/immocom.css';
import logoEiffage from './images/logo-eiffage-immobilier.png';
import fondPied from './images/fond-Pied.png';

export class HandleError extends React.Component {
    constructor(props) {
        super(props)
        this.state = { errorOccurred: false }
    }

    componentDidCatch(error, info) {
        this.setState({ errorOccurred: true });
        console.log(error);
        console.log(info);
    }

    render() {
        return (this.state.errorOccurred ?
            <Fragment>
                <Stack verticalFill className="divHome">
                    <Stack.Item align="baseline">
                        <img src={logoEiffage} alt="Eiffage Immobilier" className="logoEiffageHome" />
                    </Stack.Item>
                    <Stack.Item align="center" grow>
                        <div className="containerMessageErreurGenerique">
                            <div className="messageErreurGenerique">
                                Désolé une erreur est survenue, elle nous a été transmise afin que nous la traitions dans les plus brefs délais.
                            </div>
                            <div>
                                <PrimaryButton iconProps={{ iconName: 'CaretRight' }} onClick={() => { window.location.href = window.location.origin; }}>Retour à l'accueil</PrimaryButton>
                            </div>
                        </div>
                    </Stack.Item>
                    <Stack.Item align="end">
                        <img src={fondPied} alt="Pied de page" className="imagePiedPage" />
                    </Stack.Item>
                </Stack>

            </Fragment>
            : this.props.children)
    }
}
